module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/referral/referral-artwork-1c9e2a7d65d50aa9d949f9b7023a7de1.svg";